export const COMPANY_INFO_REQUEST = "COMPANY_INFO_REQUEST";
export const COMPANY_INFO_SUCCESS = "COMPANY_INFO_SUCCESS";
export const COMPANY_INFO_FAIL = "COMPANY_INFO_FAIL";